"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpersonationService = void 0;
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
var SeismicHelper_1 = require("../helper/SeismicHelper");
var Authentication_service_1 = require("./authentication/Authentication.service");
var Http_service_1 = require("../../core/services/http/Http.service");
var ServiceAddress_service_1 = require("../../core/services/ServiceAddress.service");
var GRANT_TYPE = 'impersonation';
var IMPERSONATION_TYPE = 'admin';
var ADMIN_IMPERSONATION_SIG = 'Seismic - Admin Impersonation';
var ImpersonationService = /** @class */ (function () {
    function ImpersonationService(httpService, serviceAddressService, authenticationService, seismicHelper) {
        this.httpService = httpService;
        this.serviceAddressService = serviceAddressService;
        this.authenticationService = authenticationService;
        this.seismicHelper = seismicHelper;
    }
    ImpersonationService.prototype.getAPIParams = function (params) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var _d, impersonatedUserId, custom_token, accessToken, client_id, authUrl, url, bodyParams, bodyForm;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _d = params || {}, impersonatedUserId = _d.impersonatedUserId, custom_token = _d.custom_token;
                        accessToken = (_a = this.authenticationService.authHelper.getAccessToken()) === null || _a === void 0 ? void 0 : _a.replace('Bearer ', '');
                        client_id = this.authenticationService.authHelper.getClientId();
                        return [4 /*yield*/, this.serviceAddressService.getServiceAddressByKey('auth')];
                    case 1:
                        authUrl = _e.sent();
                        url = authUrl + "/tenants/" + this.seismicHelper.getTenant() + "/connect/token";
                        bodyParams = {
                            client_id: client_id,
                            grant_type: GRANT_TYPE,
                            impersonation_type: IMPERSONATION_TYPE,
                            scope: (_c = (_b = window) === null || _b === void 0 ? void 0 : _b.authenticationSettings) === null || _c === void 0 ? void 0 : _c.scope,
                            access_token: custom_token || accessToken,
                        };
                        if (impersonatedUserId) {
                            bodyParams.impersonatedUserId = impersonatedUserId;
                        }
                        bodyForm = new FormData();
                        Object.keys(bodyParams).forEach(function (v) {
                            bodyForm.append(v, bodyParams[v]);
                        });
                        return [2 /*return*/, {
                                url: url,
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                },
                                bodyForm: bodyForm,
                            }];
                }
            });
        });
    };
    ImpersonationService.prototype.sendRequest = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, impersonatedUserId, custom_token, _b, url, headers, bodyForm, result, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = params || {}, impersonatedUserId = _a.impersonatedUserId, custom_token = _a.custom_token;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.getAPIParams({
                                impersonatedUserId: impersonatedUserId,
                                custom_token: custom_token,
                            })];
                    case 2:
                        _b = _c.sent(), url = _b.url, headers = _b.headers, bodyForm = _b.bodyForm;
                        return [4 /*yield*/, this.httpService.request({
                                method: 'POST',
                                url: url,
                                headers: headers,
                                body: bodyForm,
                                credentials: 'include',
                            })];
                    case 3:
                        result = _c.sent();
                        return [2 /*return*/, result];
                    case 4:
                        error_1 = _c.sent();
                        console.info('impersonation', error_1);
                        throw error_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ImpersonationService.prototype.start = function (_a) {
        var impersonatedUserId = _a.impersonatedUserId, custom_token = _a.custom_token;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.sendRequest({ impersonatedUserId: impersonatedUserId, custom_token: custom_token })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    ImpersonationService.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendRequest()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ImpersonationService.prototype.getActedUser = function (custom_token) {
        var _a;
        var accessToken = custom_token || ((_a = this.authenticationService.authHelper.getAccessToken()) === null || _a === void 0 ? void 0 : _a.replace('Bearer ', ''));
        try {
            var option = JSON.parse(atob((accessToken === null || accessToken === void 0 ? void 0 : accessToken.split('.')[1]) || ''));
            if (option.act) {
                return {
                    userId: option.act.sub,
                    userName: option.act.userName,
                    idp: option.idp,
                };
            }
            return {};
        }
        catch (error) {
            console.info('getActedUser', error);
            return {};
        }
    };
    ImpersonationService.prototype.getActedUserId = function (custom_token) {
        var actedUser = this.getActedUser(custom_token);
        return actedUser.userId || '';
    };
    ImpersonationService.prototype.getActedUserName = function (custom_token) {
        var actedUser = this.getActedUser(custom_token);
        return actedUser.userName || '';
    };
    ImpersonationService.prototype.isImpersonatingUser = function (custom_token) {
        var actedUser = this.getActedUser(custom_token);
        return (actedUser.idp || '').indexOf(ADMIN_IMPERSONATION_SIG) > -1;
    };
    ImpersonationService = __decorate([
        CommonService_decorator_1.CommonService('ImpersonationService'),
        __metadata("design:paramtypes", [Http_service_1.HttpService,
            ServiceAddress_service_1.ServiceAddressService,
            Authentication_service_1.AuthenticationService,
            SeismicHelper_1.SeismicHelper])
    ], ImpersonationService);
    return ImpersonationService;
}());
exports.ImpersonationService = ImpersonationService;
//# sourceMappingURL=Impersonation.service.js.map